// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/communication-tool/communication-tool-detail/communication-tool-detail.scss
// module id = 499
// module chunks = 0